module.exports = __webpack_public_path__ + "img/icon-takePicture.645c0ce7.svg";